export default "__VITE_ASSET__BBRZsYKK__"